module.exports = __webpack_public_path__ + "img/OBCINA PREDDVOR.946ed44f.png";